import { useState } from 'react';
import { Plus, CheckSquare } from 'lucide-react';
import { AddActivityModal } from '../activities/AddActivityModal';
import { TaskForm } from '../tasks/TaskForm';
import { useTodayStore } from '../../store/todayStore';

/**
 * Thumb-reachable quick actions for the Today view. "Log activity" and "Add
 * task" reuse the app's existing modals (each with a built-in person picker),
 * so there's no duplicated form logic. On success we refetch Today so the new
 * item shows immediately.
 */
export function QuickActionBar() {
  const [showActivity, setShowActivity] = useState(false);
  const [showTask, setShowTask] = useState(false);
  const refetch = useTodayStore((s) => s.fetch);

  return (
    <>
      {/* Sticky (not fixed): floats at the viewport bottom while scrolling a long
          day, but rests in normal flow below the content on a short one — so it
          never permanently covers the cards beneath it. */}
      <div className="sticky bottom-4 z-30 flex justify-center sm:justify-end pointer-events-none">
        <div className="flex">
          <div className="pointer-events-auto flex gap-2 rounded-full bg-white/90 dark:bg-gray-800/90 backdrop-blur shadow-lg border border-gray-200 dark:border-gray-700 p-1.5">
            <button
              type="button"
              onClick={() => setShowActivity(true)}
              className="inline-flex items-center gap-1.5 rounded-full bg-blast-600 hover:bg-blast-700 text-white px-4 py-2 text-sm font-semibold shadow-sm transition-colors"
            >
              <Plus className="h-4 w-4" /> Log activity
            </button>
            <button
              type="button"
              onClick={() => setShowTask(true)}
              className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-700 dark:text-gray-200 px-4 py-2 text-sm font-medium hover:bg-gray-50 dark:hover:bg-gray-600 transition-colors"
            >
              <CheckSquare className="h-4 w-4" /> <span>Task</span>
            </button>
          </div>
        </div>
      </div>

      <AddActivityModal
        isOpen={showActivity}
        onClose={() => setShowActivity(false)}
        onActivityCreated={() => refetch()}
      />
      <TaskForm isOpen={showTask} onClose={() => setShowTask(false)} onSuccess={() => refetch()} />
    </>
  );
}
